<!-- src/app/components/sidemenu/sidemenu.component.html -->
<tds-side-menu aria-label="Side menu" persistent collapsed="true">

  <tds-side-menu-close-button slot="close-button"></tds-side-menu-close-button>

  <!-- ADMIN: só aparece se tiver AdmUPS -->
  <tds-side-menu-item *ngIf="isAdmUPS$ | async" [selected]="isActive('/admin')">
    <a routerLink="/admin">
      <tds-icon name="profile" size="24"></tds-icon>
      Administrador
    </a>
  </tds-side-menu-item>

  <!-- TABLE MANAGEMENT: só aparece se tiver AdmUPS -->
  <tds-side-menu-item *ngIf="isAdmUPS$ | async" [selected]="isActive('/table-management')">
    <a routerLink="/table-management">
      <tds-icon name="settings" size="24"></tds-icon>
      Gerenc. Tabelas
    </a>
  </tds-side-menu-item>

  <tds-side-menu-item [selected]="isActive('/issues')">
    <a routerLink="/issues">
      <tds-icon name="star" size="24"></tds-icon>
      Lista de Issues
    </a>
  </tds-side-menu-item>

  <tds-side-menu-item [selected]="isActive('/sprint-planning')">
    <a routerLink="/sprint-planning">
      <tds-icon name="calendar" size="24"></tds-icon>
      Sprint Planning
    </a>
  </tds-side-menu-item>

  <!-- DHE: dropdown com subitens -->
  <tds-side-menu-dropdown [selected]="isActive('/dhe') || isActive('/dhe-equipes')">
    <tds-icon slot="icon" name="contact" size="24"></tds-icon>
    <span slot="label">DHE</span>
    <tds-side-menu-dropdown-list>
      <tds-side-menu-dropdown-list-item [selected]="isActive('/dhe')">
        <a routerLink="/dhe">DHE</a>
      </tds-side-menu-dropdown-list-item>
      <tds-side-menu-dropdown-list-item [selected]="isActive('/dhe-equipes')">
        <a routerLink="/dhe-equipes">Equipes</a>
      </tds-side-menu-dropdown-list-item>
    </tds-side-menu-dropdown-list>
  </tds-side-menu-dropdown>

  <tds-side-menu-item [selected]="isActive('/dashboards')">
    <a routerLink="/dashboards">
      <tds-icon name="dashboard" size="24"></tds-icon>
      Dashboards
    </a>
  </tds-side-menu-item>

  <tds-side-menu-collapse-button slot="sticky-end">Collapse</tds-side-menu-collapse-button>
</tds-side-menu>
